import declare from "dojo/_base/declare";
import StoreValuesConstructor from "./Values";

const DataStoreValues = declare(StoreValuesConstructor, {
	requestModule: "DataStore",
	requestOperation: "GetValues",
});

export = DataStoreValues;